import { render, staticRenderFns } from "./sxStus.vue?vue&type=template&id=696141bd&scoped=true"
import script from "./sxStus.vue?vue&type=script&lang=js"
export * from "./sxStus.vue?vue&type=script&lang=js"
import style0 from "./sxStus.vue?vue&type=style&index=0&id=696141bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696141bd",
  null
  
)

export default component.exports